import React from "react";

const Loader = () => {
  return <div class="lds-dual-ring"></div>;
};

export { Loader };
